import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LINK from 'constants/link.const';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToSpacelessString from 'utils/converters/fromAnyToSpacelessString.util';
import { fromPropsToQuery, fromPropsToQueryString } from 'utils/converters/props/path.util';
import navFor from 'utils/links/navFor.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import PopupModalContainer from 'common/PopupModal';
import HeaderContainer from 'onboarding/common/Header';
import OnboardingFooter from 'onboarding/common/OnboardingFooter';
import { addRole, clearRoleState, editRole } from 'onboarding/roles/actions';
import AddRole from 'onboarding/roles/AddRole.component';

const L = logger('AddRoleWrap');

class AddRoleWrap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      roleName: asObject(props.location.state).roleName || '',
      isFooterButtonActive: fromAnyToBool(props.location.state),
      errorMessage: '',
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.salon) {
      navFor('AddRoleWrap.componentWillMount()', this.props).push({
        pathname: LINK.onboardingType,
        search: fromPropsToQueryString(this.props),
      });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isSaved) {
      this.props.clearRoleState();
      navFor('AddRoleWrap.componentWillReceiveProps()', this.props).push({
        pathname: LINK.onboardingRoles,
        search: fromPropsToQueryString(this.props),
      });
    }
  }

  onRoleNameChange = (roleName) =>
    void this.setState({ roleName, isFooterButtonActive: fromAnyToSpacelessString(roleName).length > 0 });

  onFooterButtonClicked = () => {
    const { editRole, location, addRole, salon } = this.props;
    const { roleName } = this.state;

    // NOTE: workaround for missing id on refresh
    const salonId = asObject(salon).id || fromPropsToQuery(this.props).salonId;
    const roleId = asObject(location.state).id;

    L.unignore(
      'onFooterButtonClicked()',
      { roleName, roleId, salonId },
      roleId ? editRole(roleName, roleId, salonId) : addRole(roleName, salonId),
    );
  };

  hideError = () => void this.setState({ errorMessage: '' });

  render() {
    const { isFooterButtonActive, errorMessage } = this.state;
    const { roles, isPosting, location } = this.props;

    const title = roles.length > 0 ? 'Staff Titles' : 'Next Up, Staff Titles';
    const description = 'Let’s add titles for your different stylist levels.';

    return (
      <div data-bem="AddRoleWrap" className="content-wrap">
        {errorMessage && (
          <PopupModalContainer
            popupTitle="Error"
            popupMessage={errorMessage}
            buttonText="Okay"
            buttonCallback={this.hideError}
          />
        )}

        <HeaderContainer titleFirstPart={title} description={description} />

        <AddRole onRoleNameChange={this.onRoleNameChange} roleName={asObject(location.state).roleName} />

        <OnboardingFooter
          isFooterButtonActive={isFooterButtonActive}
          onButtonClick={this.onFooterButtonClicked}
          isLoading={isPosting}
        />

        {isPosting && <div className="load-blocker" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.onboarding.roles,
  salon: state.currentSalon,
  isPosting: state.onboarding.roles.isPosting,
  isSaved: state.onboarding.roles.isSaved,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ addRole, editRole, clearRoleState }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddRoleWrap);
